import {
  Box,
  Typography,
  Button,
  makeStyles,
  CardMedia,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import { useTranslate } from "react-admin";
import { useHistory } from "react-router-dom";

import CorrectIcon from "../../../assets/correct.png";
import ReceiptDialog from "./ReceiptDialog";
const useSuccessPageStyles = makeStyles((theme) => ({
  allContainer: {
    margin: "0 auto",
    width: 581,
    height: 489,
    marginTop: 13,
    backgroundColor: "#ebebeb",
  },
  center: {
    margin: "0 auto",
  },
  image: {
    marginTop: 144,
    width: 152,
    height: 152,
  },
  title: {
    marginTop: 31,
  },
  subtitle: {
    fontSize: 32,
  },
  buttonContainer: {
    marginTop: 96,
    display: "flex",
    justifyContent: "space-around",
    width: 581,
  },
  button: {
    width: 272,
    height: 69,
  },
  buttonLabelPrimary: theme.buttonLabelPrimary,
  buttonLabelPrimaryOutlined: theme.buttonLabelPrimaryOutlined,
}));
/**
 *
 * @returns
 */
const PaymentSuccessView = () => {
  const translate = useTranslate();
  const classes = useSuccessPageStyles();
  const [openReceipt, setOpenReceipt] = useState(false);
  const history = useHistory();
  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.push({
          pathname: "/",
        });
        // Code here will run when back button fires. Note that it's after the `return` for useEffect's callback; code before the return will fire after the page mounts, code after when it is about to unmount.
      }
    };
  });
  return (
    <Box>
      <CardMedia
        className={[classes.center, classes.image]}
        image={CorrectIcon}
        title={translate("ra.text.registerSuccess.congratulation")}
      />
      <Typography
        variant="h2"
        align="center"
        className={[classes.center, classes.title]}
      >
        {translate("ra.text.registerSuccess.congratulation")}
      </Typography>
      <Typography
        align="center"
        className={[classes.center, classes.subtitle]}
        noWrap
      >
        {translate("ra.text.paymentSuccess.yourPaymentwasSuccessful")}
      </Typography>
      <Box className={[classes.center, classes.buttonContainer]}>
        <Button
          variant="outlined"
          color="primary"
          className={classes.button}
          onClick={() =>
            history.push({
              pathname: "/",
            })
          }
        >
          <Typography className={classes.buttonLabelPrimaryOutlined}>
            {translate("ra.text.registerSuccess.backtoHome")}
          </Typography>
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => setOpenReceipt(true)}
        >
          <Typography className={classes.buttonLabelPrimary}>
            {translate("ra.text.paymentSuccess.printReceipt")}
          </Typography>
        </Button>
        <ReceiptDialog
          open={openReceipt}
          onClose={() => setOpenReceipt(false)}
          receipt={history.location.state.receipt}
          payment={history.location.state.payment}
          paymentTransaction={history.location.state.paymentTransaction}
        />
      </Box>
    </Box>
  );
};

export default PaymentSuccessView;
